import { Button, ButtonProps } from '@mui/material'
import { T } from '@transifex/react'
import { Link } from 'react-router-dom'

type CancelProps = {
  elementId?: string
  cancelText?: React.ReactNode
  to?: string | number
  onClick?: () => void
}

const Cancel = ({ elementId, to, onClick, cancelText }: CancelProps) => {
  const renderCancelText = () => {
    return cancelText ? cancelText : <T _str="Cancel" />
  }

  const getButtonProps = (): ButtonProps<React.ElementType, { to?: string | number }> => {
    const id = elementId || 'btnCancel'
    if (to) {
      return {
        id,
        to: to,
        component: Link,
      }
    } else {
      return { onClick, id }
    }
  }

  return (
    <Button variant="outlined" type="button" {...getButtonProps()}>
      {renderCancelText()}
    </Button>
  )
}

export default Cancel
